import { cibFacebook, cibTwitter, cibInstagram } from '@coreui/icons'
import {
  cilEnvelopeOpen,
  cilLocationPin,
  cilCalendar,
  cilNewspaper,
  cilCloudDownload,
  cilDescription,
  cilDevices,
  cilSearch,
  cilArrowThickRight,
  cilCart,
  cilUser,
  cilColorFill,
  cilCog,
  cilSettings,
  cilSave,
  cilRouter,
  cilFax,
  cilPrint,
  cilTerminal,
  cilTask,
  cilNotes,
} from '@coreui/icons'
export const iconsSet = Object.assign(
  {
    cilEnvelopeOpen,
    cilLocationPin,
    cilCalendar,
    cilNewspaper,
    cilCloudDownload,
    cilDescription,
    cilDevices,
    cilSearch,
    cilArrowThickRight,
  },
  {
    cibFacebook,
    cibTwitter,
    cibInstagram,
  },
  {
    cilCart,
    cilUser,
    cilColorFill,
    cilCog,
    cilSettings,
    cilSave,
    cilRouter,
    cilFax,
    cilPrint,
    cilTerminal,
    cilTask,
    cilNotes,
  },
)
